import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_USERS,
  CREATE_USERS,
  UPDATE_USERS,
  DELETE_USERS,
} from './actionType';

import { UsersApiResponseSuccess, UsersApiResponseError } from './action';

import {
  getUsers as getUser,
  createUsers as createUser,
  updateUsers as updateUser,
  deleteUsers as deleteUser,
} from '../../helpers/backend_helper';
import { toast } from 'react-toastify';
import { notifyError, notifySuccess } from '../../components/notify';

function* getUsers() {
  try {
    const response = yield call(getUser);
    yield put(UsersApiResponseSuccess(GET_USERS, response));
  } catch (error) {
    yield put(UsersApiResponseError(GET_USERS, error));
  }
}

function* createUsers(data) {
  try {
    const response = yield call(createUser, data.payload.data);
    yield put(UsersApiResponseSuccess(CREATE_USERS, response));
    notifySuccess('Usuário adicionada com sucesso!');
  } catch (error) {
    yield put(UsersApiResponseError(CREATE_USERS, error));
    notifyError('Erro ao adicionar usuário!');
  }
}

function* updateUsers(data) {
  try {
    const response = yield call(updateUser, data.payload.data);
    yield put(UsersApiResponseSuccess(UPDATE_USERS, response));
    notifySuccess('Usuário atualizada com sucesso!');
  } catch (error) {
    yield put(UsersApiResponseError(UPDATE_USERS, error));
    notifyError('Erro ao atualizar usuário!');
  }
}

function* deleteUsers(data) {
  try {
    const response = yield call(deleteUser, data.payload.id);
    yield put(UsersApiResponseSuccess(DELETE_USERS, response));
    notifySuccess('Usuário deletado com sucesso!');
  } catch (error) {
    yield put(UsersApiResponseError(DELETE_USERS, error));
    notifyError('Erro ao deletar usuário!');
  }
}

export function* watchGetUsers() {
  yield takeEvery(GET_USERS, getUsers);
}

export function* watchCreateUsers() {
  yield takeEvery(CREATE_USERS, createUsers);
}

export function* watchUpdateUsers() {
  yield takeEvery(UPDATE_USERS, updateUsers);
}

export function* watchDeleteUsers() {
  yield takeEvery(DELETE_USERS, deleteUsers);
}

function* UsersSaga() {
  yield all([fork(watchGetUsers)]);
  yield all([fork(watchCreateUsers)]);
  yield all([fork(watchUpdateUsers)]);
  yield all([fork(watchDeleteUsers)]);
}

export default UsersSaga;
